import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { firstAllowedUrl } from '@/components/layout/data/sidebar-data'
import { Dashboard } from '@/features/dashboard'

export const Route = createFileRoute('/_authenticated/')({
  // no dashboard permission -> the first menu this user may open
  beforeLoad: () => {
    const { role, permissions } = useAuthStore.getState().auth
    if (role?.name === 'admin' || permissions?.includes('dashboard.read'))
      return
    const url = firstAllowedUrl((p) => !!permissions?.includes(p), role?.name)
    if (url && url !== '/') throw redirect({ to: url })
  },
  component: Dashboard,
})
